import { Injectable } from '@angular/core';
import {
   ActivatedRouteSnapshot,
   RouterStateSnapshot,
   UrlTree,
} from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';
import { OrderCheckService } from '../services/order-check.service';
import { OrderService } from '../services/order.service';

@Injectable({
   providedIn: 'root',
})
export class CanDeactivateMenuPageGuard {
   constructor(
      private orderCheckService: OrderCheckService,
      private orderService: OrderService,
      private notificationService: NotificationService,
   ) {}

   canDeactivate(
      _component: unknown,
      _currentRoute: ActivatedRouteSnapshot,
      _currentState: RouterStateSnapshot,
      nextState?: RouterStateSnapshot,
   ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      // Destinos que já tratam a confirmação (ou não devem avisá-la de novo).
      const nextUrl = nextState?.url ?? '';
      if (nextUrl.includes('/carrinho') || nextUrl.includes('/comandaemesa')) {
         return of(true);
      }

      const parameterization = this.orderCheckService.getParameterization();
      if (!parameterization?.CompanyId) {
         return of(true);
      }

      const order = this.orderService.getOrder(parameterization.CompanyId);
      if (!order?.ItemsQuantity || order.ItemsQuantity <= 0) {
         return of(true);
      }

      return from(
         this.notificationService.showConfirmBox(
            null,
            'Existem itens no carrinho. Deseja sair mesmo assim?',
            'warning',
         ),
      ).pipe(map((result) => result.isConfirmed));
   }
}
